// Generated by ReScript, PLEASE EDIT WITH CARE


var titleCorrection = {
  id: "6f9b9c34-5758-4b1c-89f4-6fca18f0bee2",
  defaultMessage: "Order correction"
};

var titleCorrectionHistory = {
  id: "ab696dd7-ff18-4678-9f23-9f3a9e3b02e5",
  defaultMessage: "Order correction history"
};

var initialValues = {
  id: "c98865b7-c228-4b9a-a8de-efb30537c8bb",
  defaultMessage: "Initial value"
};

var correctionValues = {
  id: "b50e5ac4-d5f9-466f-9519-d0e216a28f5b",
  defaultMessage: "Correction"
};

var initialValuesPerf = {
  id: "bd624972-40ee-45fb-b210-cdff5a3c278d",
  defaultMessage: "Initial actions"
};

var correctionValuesPerf = {
  id: "206bbba1-7650-4071-b426-0c2ade3c5032",
  defaultMessage: "Action correction"
};

var initialCarValues = {
  id: "3233becc-b582-48fe-8b7e-12bf0a683411",
  defaultMessage: "Initial used car values"
};

var correctionCarValues = {
  id: "994d038e-c355-4021-988c-94ad66cd87cc",
  defaultMessage: "Used vehicle correction"
};

var appendCarInfo = {
  id: "4fa37db5-c1ed-4881-be34-eb0097c0ff4b",
  defaultMessage: "Add an used vehicle info"
};

var validateCorrection = {
  id: "06f473dc-ec50-4bc9-9663-6c4c5d189b9b",
  defaultMessage: "Validate the correction"
};

var correctionsSelector = {
  id: "ae9f2904-735e-4251-9e88-6d04828d282d",
  defaultMessage: "Select a correction date"
};

var correctionsDateTitle = {
  id: "aa4efdc6-1292-46f2-87c6-0671a17d3110",
  defaultMessage: "Correction on {date}"
};

var correctionCarDateValues = {
  id: "f5d255c4-c585-4e75-969d-2103fa4315a1",
  defaultMessage: "Used vehicle correction on {date}"
};

var successMessage = {
  id: "f3298db5-8eb8-4996-b3f1-d371977e1cc1",
  defaultMessage: "Your changes have been saved"
};

var lastUndeployedMod = {
  id: "90f5785d-70c2-478f-92a1-75e6c3ad4d00",
  defaultMessage: "Value corrected on"
};

var orderNotDeliveredIssue = {
  id: "81c763db-6db9-49a9-a5f3-a470c779d8e4",
  defaultMessage: "The order is not delivered and cannot be corrected"
};

var amountPerf = {
  id: "a08abb5f-0455-4560-8710-58a7233d80cc",
  defaultMessage: "Action amount 1"
};

var amountPerf2 = {
  id: "6d7d4862-c847-40a5-aaff-d66d91db7667",
  defaultMessage: "Action amount 2"
};

var amountPerf3 = {
  id: "32da1812-3523-4827-a4ea-00381eb571e2",
  defaultMessage: "Action amount 3"
};

var idPerf = {
  id: "2493f35c-6d28-4621-8d8e-d361472b33ec",
  defaultMessage: "ID Action 1"
};

var idPerf2 = {
  id: "344a0010-6330-49fd-a413-9e6794b6fcac",
  defaultMessage: "Action ID 2"
};

var idPerf3 = {
  id: "3b28ea72-eaff-4b0d-b9f9-50823f40ba33",
  defaultMessage: "Action ID 3"
};

var typePerf = {
  id: "9141eead-d7b8-48a4-9c4f-3deed3a5219b",
  defaultMessage: "Action type 1"
};

var typePerf2 = {
  id: "95b91114-09ae-43ba-ac56-31d4ccf546d0",
  defaultMessage: "Action type 2"
};

var typePerf3 = {
  id: "3a640b07-3919-49b1-aea2-27a3ec3d0560",
  defaultMessage: "Action type 3"
};

var correctionBlockedTooltip = {
  id: "384b5ec8-2880-41c5-86e7-bacad08a49b6",
  defaultMessage: "These fields cannot be changed when order is archived or not delivered or has been delivered for less than 7 days"
};

var correctionWillUpdateTomorrow = {
  id: "ad8b7941-5d94-4324-aeca-39c83b88bfcb",
  defaultMessage: "The correction will be effective tomorrow"
};

var onlySevenPlusBlocked = {
  id: "b85a28e6-8c6d-4c06-9490-796dd3fc9008",
  defaultMessage: "Some fields cannot be corrected if the order has not been delivered for more than 7 days."
};

var exitParcDeleteWarning = {
  id: "8ecef120-c26d-4e35-b2d0-a04c25bedc29",
  defaultMessage: "Deleting the PARC exit date will result in deleting the reselling order"
};

export {
  titleCorrection ,
  titleCorrectionHistory ,
  initialValues ,
  correctionValues ,
  initialValuesPerf ,
  correctionValuesPerf ,
  initialCarValues ,
  correctionCarValues ,
  appendCarInfo ,
  validateCorrection ,
  correctionsSelector ,
  correctionsDateTitle ,
  correctionCarDateValues ,
  successMessage ,
  lastUndeployedMod ,
  orderNotDeliveredIssue ,
  amountPerf ,
  amountPerf2 ,
  amountPerf3 ,
  idPerf ,
  idPerf2 ,
  idPerf3 ,
  typePerf ,
  typePerf2 ,
  typePerf3 ,
  correctionBlockedTooltip ,
  correctionWillUpdateTomorrow ,
  onlySevenPlusBlocked ,
  exitParcDeleteWarning ,
}
/* No side effect */
